import { Outlet, useNavigate, useLocation } from 'react-router'
import { HamburgerMenu } from 'iconsax-reactjs'
import { Avatar, AvatarFallback, AvatarImage } from '../../shared/ui/avatar'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Sidebar, useSidebar } from '../../shared/ui/sidebar'
import { Button } from '../../shared/ui/button'
import { useSelector, useDispatch } from 'react-redux'
import { cn, getInitials } from '../../shared/lib/utils'
import UserDropdown from '../../shared/components/UserDropdown'
import SideNav from '../../features/navigation/components/SideNav'
import { useInactivityTimeout } from '../../hooks/use-inactivity-timeout'
import { useCallback } from 'react'
import { logout } from '../../redux/slices/authSlice'

const AppLayout = () => {
  const { toggleSidebar } = useSidebar()
  const users = useSelector((state: any) => state?.users);
  const userFullName = users ? `${users.firstName || ""} ${users.lastName || ""}`.trim() : "";
  const profileImage = users?.profileImage;
  const { open } = useSidebar()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const handleInactivityLogout = useCallback(() => {
    localStorage.removeItem('token')
    dispatch(logout())
    navigate('/', { replace: true })
  }, [dispatch, navigate])

  useInactivityTimeout({ onLogout: handleInactivityLogout })

  // Full screen standalone flows (e.g. Complete OTC transfer) hide sidebar navigation entirely
  const isFullScreenPage =
    location.pathname.includes('/complete-transfer') ||
    location.pathname.includes('/kyb-compliance/update-information')

  if (isFullScreenPage) {
    return (
      <main className="w-full min-h-screen bg-white">
        <Outlet />
      </main>
    )
  }
  return (
    <main className="flex flex-col w-full h-screen p-2 overflow-hidden md:flex-row md:p-2 lg:p-4 bg-primary-60">
      <aside className='hidden md:block'>
        <SideNav />
      </aside>
      <Sidebar className='md:hidden'>
        <SideNav />
      </Sidebar>
      <nav className="flex items-center justify-between p-0 mx-0 md:hidden">
        <Button onClick={toggleSidebar} variant="ghost" size="icon">
          <HamburgerMenu />
        </Button>

        <UserDropdown align="end">
          <Button className="" variant="ghost" size="icon">
            <Avatar className='w-8 h-8'>
              <AvatarImage
                src={profileImage}
                alt="@profile picture"
                className=""
              />
              <AvatarFallback className='text-xs text-white bg-primary-30'>{getInitials
                (userFullName)}</AvatarFallback>
            </Avatar>

            <div className='flex flex-col'>
              <ChevronUp size={14} className='text-gray-70' />
              <ChevronDown size={14} className='text-gray-70' />
            </div>
          </Button>
        </UserDropdown>
      </nav>
      <section className={cn("w-full md:ml-auto md:w-[calc(100%-96px)] min-h-[80vh] bg-white overflow-y-auto rounded-xl rounded-t-xl",
        open ? "lg:w-[calc(100%-248px)]" : "lg:w-[calc(100%-96px)]"
      )}>
        {/* <CustomHeader title="Dashboard" >
          <p className='flex text-base font-[450] items-center gap-2'><Setting4 size={20} /> Customise</p>
        </CustomHeader> */}
        <Outlet />
      </section>
    </main>
  );
};

export default AppLayout;
